import { TVG_THEME, ThemeProps } from "../../theme";

export const useTheme = (): ThemeProps => TVG_THEME;
